// Mirrors the backend PasswordPolicy (PasswordPolicy.java). Keep the two in sync.
export const MIN_PASSWORD_LENGTH = 8;

/** @returns {Array<[boolean, string]>} each rule as [satisfied, label] */
export function passwordRules(password) {
  return [
    [password.length >= MIN_PASSWORD_LENGTH, `${MIN_PASSWORD_LENGTH}+ characters`],
    [/[A-Z]/.test(password), "One uppercase letter"],
    [/\d/.test(password), "One number"],
    [/[^A-Za-z0-9]/.test(password), "One symbol"],
  ];
}

export function passwordMeetsRules(password) {
  return passwordRules(password).every(([ok]) => ok);
}
